import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const FooterGrid = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(1),
  paddingRight: theme.spacing(2),
  flexGrow: 1,
  display: "flex",
  alignItems: "flex-end",
}));
